import { connect } from 'react-redux';
import Habits from './Habits';

export default connect()(Habits);



// WEBPACK FOOTER //
// ./components/Habits/index.js